import { AccessDeniedWrapper, AccessDeniedHeader, AccessDeniedSubheader } from '@/bundle/pages/AccessDeniedPage/styles';
import LockIcon from './image/Lock.svg?react';
import { Button } from '@/components/Button/Button';
import { useNavigate } from 'react-router';
import { useUser } from '@/context/userContext';
import { getDashboardRedirectPath } from '../../Auth/LoginFlow/LoginPage/const/const';
import { getSwitchRolePath } from '../SwitchRolePage/path/path';
import { getFirstRole } from '@/helpers/userHelpers';

export const AccessDeniedPage = () => {
  const navigate = useNavigate();
  const { user, hasMultipleUserRoles } = useUser();

  const redirectToDashboard = () => {
    if (hasMultipleUserRoles) {
      return navigate(getSwitchRolePath());
    }

    const activeRole = getFirstRole(user.active_roles);
    const dashboardPath = getDashboardRedirectPath(activeRole);

    return navigate(dashboardPath);
  };

  return (
    <AccessDeniedWrapper>
      <LockIcon />
      <AccessDeniedHeader>Access Forbidden</AccessDeniedHeader>
      <AccessDeniedSubheader>Sorry, you don't have access to view this page.</AccessDeniedSubheader>
      <Button width={200} onClick={redirectToDashboard}>
        Go To Dashboard
      </Button>
    </AccessDeniedWrapper>
  );
};
